/**
 * Product categories — cross-domain enum representing the business-level
 * classification of a product (set in CMS via `product_category`).
 *
 * NOTE:
 * - Intentionally separate from legacy `product.type` (e.g. M2PA),
 *   which represents a subtype/code rather than a category.
 * - Used by: product domain, catalog filters, colorMode, i18n strings.
 */

export const PRODUCT_CATEGORY = {
  PRODUCT:            'product',
  REAL_ESTATE:        'real_estate',
  UNIT:               'unit',
  APARTMENT_STANDARD: 'apartment_standard',
  APARTMENT_PREMIUM:  'apartment_premium',
  APARTMENT_LUXURY:   'apartment_luxury',
  STUDIO:             'studio',
  DETACHED:           'detached',
  SEMI_DETACHED:      'semi_detached',
  TOWNHOUSE:          'townhouse',
  COMMERCIAL:         'commercial',
  STORE:              'store',
  HOTEL_ROOM:         'hotel_room',
  HOTEL_SUITE:        'hotel_suite',
}

export const ALL_PRODUCT_CATEGORIES = Object.values(PRODUCT_CATEGORY)
